export default "__VITE_ASSET__2Xg8iJNi__"